import { render } from "./LoadSpinner.vue?vue&type=template&id=6c4b0c96&scoped=true"
import script from "./LoadSpinner.vue?vue&type=script&lang=js"
export * from "./LoadSpinner.vue?vue&type=script&lang=js"

import "./LoadSpinner.vue?vue&type=style&index=0&id=6c4b0c96&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c4b0c96"]])

export default __exports__